import Image from "next/image";
import styles from "./Footer.module.css";
import { useSelector } from "react-redux";
import { selectParentHeaderAndFooterData } from "../../redux/dataSlice";
import { processFooter } from "../../utils/parentMapping";
import NavBarFooter from "../NavBarFooter";

const Footer = (data) => {
 // const data = useSelector(selectParentHeaderAndFooterData);
  const processedData = processFooter(data?.data?.data);

  const handleAppStore = () => {
    window.open(processedData?.appleStoreLink, '_blank');
  };

  const handleGooglePlay = () => {
    window.open(processedData?.googlePlayLink, '_blank');
  };

  return (
    <div className={styles.footer} data-testid="footer-container-id">
      <div>
        {processedData?.logo && (
          <Image
            className={styles.educationLogo}
            width={238.58}
            height={64.05}
            src={processedData?.logo}
            alt="logo"
          />
        )}
      </div>

      <div className={styles.row_desc}>{processedData?.desc}</div>

      <div className={styles.row_menu}>
        <div className={styles.left_menu}>
          <NavBarFooter data={processedData?.links} flag={false} />
        </div>
        <div className={styles.right_menu}>
          {processedData?.appleStoreIcon && (
            <Image
              src={processedData.appleStoreIcon}
              alt="appStore"
              height={40}
              width={125}
              onClick={handleAppStore}
              className={styles.link_icon}
            />
          )}
          {processedData?.googlePlayIcon && (
            <Image
              src={processedData.googlePlayIcon}
              alt="googlePlay"
              height={40}
              width={125}
              onClick={handleGooglePlay}
              className={styles.link_icon}
            />
          )}
        </div>
      </div>

      <hr className={styles.horizontalLine} />

      <div className={styles.page_row}>
        <span className={styles.itemLeft}>
          <NavBarFooter data={processedData?.sublinks} flag={true} />
        </span>
      </div>

      <span className={styles.copyright}>{processedData?.copyright}</span>
    </div>
  );
};

export default Footer;
